/* src/app/shared/hrm2/hrm2.component.scss */
.hrm {
  position: absolute;
  width: 100vw;
  height: 25vw;
  background-size: cover;
  background-position: bottom;
}
.hrmIndex {
  position: absolute;
  top: -75vw;
  width: 100vw;
  height: 100vw;
  background-position: bottom;
  background-size: cover;
  background-image: url(/assets/images/hr_new_index.png);
}
.hrmParent {
  width: 100vw;
  height: 25vw;
  overflow: hidden;
}
.hrmStats {
  width: 100vw;
  height: 10vw;
  display: inline-flex;
  position: absolute;
  text-align: center;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.hearts {
  display: inline-flex;
}
.hrm0 {
  position: absolute;
  font-size: xx-large;
}
.hrm1 {
  color: rgb(76, 76, 76);
  font-size: xx-large;
}
.hrm2 {
  color: rgb(0, 173, 239);
  font-size: xx-large;
}
.hrm3 {
  color: rgb(94, 186, 70);
  font-size: xx-large;
}
.hrm4 {
  color: rgb(240, 90, 40);
  font-size: xx-large;
}
.hrm5 {
  color: rgb(237, 28, 36);
  font-size: xx-large;
}
.hrmStats h1,
.hrmStats h2 {
  margin: 0;
  font-size: xx-large;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black;
  color: white;
  font-weight: bold;
}
h1 {
  font-size: large !important;
}
/*# sourceMappingURL=hrm2.component.css.map */
